/**
 * Side-effect-only module that exposes Leaflet on the global object.
 *
 * Several Leaflet plugins (leaflet.chinatmsproviders, leaflet.gridlayer.googlemutant,
 * esri-leaflet-vector internals) reference a bare `L` global at module-evaluation
 * time. esbuild does not auto-bind `import * as L from 'leaflet'` to `window.L`,
 * so the plugins crash with `ReferenceError: L is not defined` when their lazy
 * chunk loads.
 *
 * Import this file once, before any leaflet-plugin import, in the same module
 * that pulls in those plugins (currently `maps.constants.ts`). ES module
 * evaluation is depth-first, so this file's body — including the assignment —
 * runs to completion before the next import in the consuming module begins.
 */
import * as LeafletNamespace from 'leaflet';

const L = (LeafletNamespace as any).default ?? LeafletNamespace;
(globalThis as any).L = (globalThis as any).L ?? L;
